export default __webpack_public_path__ + "static/media/shovel.6123df47.svg";